import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_15 = { class: "control-label col-sm-6" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_18 = { class: "control-label col-sm-6" }
const _hoisted_19 = { class: "col-sm" }
const _hoisted_20 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_21 = { class: "control-label col-sm-6" }
const _hoisted_22 = { class: "col-sm" }
const _hoisted_23 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_24 = { class: "control-label col-sm-6" }
const _hoisted_25 = { class: "col-sm" }
const _hoisted_26 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_27 = { class: "control-label col-sm-6" }
const _hoisted_28 = { class: "col-sm" }
const _hoisted_29 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_30 = { class: "control-label col-sm-6" }
const _hoisted_31 = { class: "col-sm" }
const _hoisted_32 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_33 = { class: "control-label col-sm-6" }
const _hoisted_34 = { class: "col-sm" }
const _hoisted_35 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_36 = { class: "control-label col-sm-6" }
const _hoisted_37 = { class: "col-sm" }
const _hoisted_38 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_39 = { class: "control-label col-sm-6" }
const _hoisted_40 = { class: "col-sm" }
const _hoisted_41 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_42 = { class: "control-label col-sm-6" }
const _hoisted_43 = { class: "col-sm" }
const _hoisted_44 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_45 = { class: "control-label col-sm-6" }
const _hoisted_46 = { class: "col-sm" }
const _hoisted_47 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_48 = { class: "control-label col-sm-6" }
const _hoisted_49 = { class: "col-sm" }
const _hoisted_50 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_51 = { class: "control-label col-sm-6" }
const _hoisted_52 = { class: "col-sm" }
const _hoisted_53 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_54 = { class: "control-label col-sm-6" }
const _hoisted_55 = { class: "col-sm" }
const _hoisted_56 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_57 = { class: "control-label col-sm-6" }
const _hoisted_58 = { class: "col-sm" }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_61 = { class: "control-label col-sm-6" }
const _hoisted_62 = { class: "col-sm" }
const _hoisted_63 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_64 = { class: "control-label col-sm-6" }
const _hoisted_65 = { class: "col-sm" }
const _hoisted_66 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_67 = { class: "control-label col-sm-6" }
const _hoisted_68 = { class: "col-sm" }

import { ref, watch , inject} from 'vue';
import { usePreventivo } from '../../composable/usePreventivo';
import FormImmobiliareHelper from "./../../pages/preventivi/json/immobiliare/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormImmobiliarePermute',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo','infoCompilazione'],
  setup(__props, { emit: __emit }) {

const props = __props;
const {
  categoriaImmobiliare
} = usePreventivo();
let validazione;
const validazioneEquoCompenso = ref();
const testoInfoCompilazione = ref([]);
const { regimeFiscale } = inject('regimeFiscale')
const emits = __emit;
switch (props.formName) {
  case 'permutaTraBeniRegistro':
    validazione = categoriaImmobiliare['sottocategoriaPermute']['permutaTraBeniRegistro'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaPermute']['permutaTraBeniRegistro'];
    break
  case 'permutaTraBeniIva':
    validazione = categoriaImmobiliare['sottocategoriaPermute']['permutaTraBeniIva'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaPermute']['permutaTraBeniIva'];
    break
}
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if(validazione){
  validazione.tipo_preventivo.value = 'immobiliare/permute/' + props.tipoPreventivo.data.url
}
watch(validazione, (newValue, oldValue) => {
  emits('changeDatiPreventivo');
}, { deep: true })

function secondaCasaSelezionatoPrimoBene (event) {
  if (event.target.checked) {
    validazione.detrazione_credito_imposta_prima_permuta.value = '';
  }
}
function secondaCasaSelezionatoSecondoBene (event) {
  if (event.target.checked) {
    validazione.detrazione_credito_imposta_seconda_permuta.value = '';
  }
}
function ritenutaAccontoSelezionata(event){

}
testoInfoCompilazione.value =  FormImmobiliareHelper.sottocategoriaPermute[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
let indexHelperClosing = {
  calcolo: FormImmobiliareHelper.sottocategoriaPermute[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _component_base_select = _resolveComponent("base-select")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'permutaTraBeniRegistro')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "row crm:items-center crm:mb-6" }, [
            _createElementVNode("div", { class: "col-sm" }, [
              _createElementVNode("p", { class: "crm:font-bold" }, "Primo Lotto Permuta")
            ])
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_prima_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_prima_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_input_text, {
                id: "valore_prima_permuta",
                name: "valore_prima_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).valore_prima_permuta,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).valore_prima_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_compreso_primo_garage_prima_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_compreso_primo_garage_prima_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_input_text, {
                id: "rendita_catastale_compreso_primo_garage_prima_permuta",
                name: "rendita_catastale_compreso_primo_garage_prima_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).rendita_catastale_compreso_primo_garage_prima_permuta,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).rendita_catastale_compreso_primo_garage_prima_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
              _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_compreso_secondo_garage_prima_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_compreso_secondo_garage_prima_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_base_input_text, {
                id: "rendita_catastale_compreso_secondo_garage_prima_permuta",
                name: "rendita_catastale_compreso_secondo_garage_prima_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).rendita_catastale_compreso_secondo_garage_prima_permuta,
                "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).rendita_catastale_compreso_secondo_garage_prima_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_terreno_prima_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_terreno_prima_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_base_input_text, {
                id: "valore_terreno_prima_permuta",
                name: "valore_terreno_prima_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).valore_terreno_prima_permuta,
                "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).valore_terreno_prima_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
              _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_terreno_prima_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_terreno_prima_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_base_input_text, {
                id: "rendita_catastale_terreno_prima_permuta",
                name: "rendita_catastale_terreno_prima_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).rendita_catastale_terreno_prima_permuta,
                "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).rendita_catastale_terreno_prima_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_18, [
              _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_imposta_prima_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_imposta_prima_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_base_input_text, {
                id: "detrazione_credito_imposta_prima_permuta",
                name: "detrazione_credito_imposta_prima_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).detrazione_credito_imposta_prima_permuta,
                "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).detrazione_credito_imposta_prima_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_21, [
              _createTextVNode(_toDisplayString(_unref(validazione).terreno_agricolo_prima_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.terreno_agricolo_prima_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_base_input_checkbox, {
                class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                name: "terreno_agricolo_prima_permuta",
                label: "Sì, è un terreno agricolo",
                "validate-to": _unref(validazione).terreno_agricolo_prima_permuta,
                "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).terreno_agricolo_prima_permuta) = $event))
              }, null, 8 /* PROPS */, ["class", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_24, [
              _createTextVNode(_toDisplayString(_unref(validazione).terreno_pertinenza_prima_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.terreno_pertinenza_prima_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_base_input_checkbox, {
                class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                name: "terreno_pertinenza_prima_permuta",
                label: "Si, è di pertinenza",
                "validate-to": _unref(validazione).terreno_pertinenza_prima_permuta,
                "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).terreno_pertinenza_prima_permuta) = $event))
              }, null, 8 /* PROPS */, ["class", "validate-to"])
            ])
          ]),
          _cache[24] || (_cache[24] = _createElementVNode("hr", { class: "crm:mt-2! crm:mb-4!" }, null, -1 /* CACHED */)),
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "row crm:items-center crm:mb-6" }, [
            _createElementVNode("div", { class: "col-sm" }, [
              _createElementVNode("p", { class: "crm:font-bold" }, "Secondo Lotto in Permuta")
            ])
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_27, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_seconda_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_seconda_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_base_input_text, {
                id: "valore_seconda_permuta",
                name: "valore_seconda_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).valore_seconda_permuta,
                "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).valore_seconda_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_30, [
              _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_compreso_primo_garage_seconda_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_compreso_primo_garage_seconda_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_base_input_text, {
                id: "rendita_catastale_compreso_primo_garage_seconda_permuta",
                name: "rendita_catastale_compreso_primo_garage_seconda_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).rendita_catastale_compreso_primo_garage_seconda_permuta,
                "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).rendita_catastale_compreso_primo_garage_seconda_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_33, [
              _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_compreso_secondo_garage_seconda_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_compreso_secondo_garage_seconda_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_base_input_text, {
                id: "rendita_catastale_compreso_secondo_garage_seconda_permuta",
                name: "rendita_catastale_compreso_secondo_garage_seconda_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).rendita_catastale_compreso_secondo_garage_seconda_permuta,
                "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).rendita_catastale_compreso_secondo_garage_seconda_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_36, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_terreno_seconda_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_terreno_seconda_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_base_input_text, {
                id: "valore_terreno_seconda_permuta",
                name: "valore_terreno_seconda_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).valore_terreno_seconda_permuta,
                "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).valore_terreno_seconda_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_39, [
              _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_terreno_seconda_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_terreno_seconda_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_base_input_text, {
                id: "rendita_catastale_terreno_seconda_permuta",
                name: "rendita_catastale_terreno_seconda_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).rendita_catastale_terreno_seconda_permuta,
                "onUpdate:validateTo": _cache[12] || (_cache[12] = $event => ((_unref(validazione).rendita_catastale_terreno_seconda_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_42, [
              _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_imposta_seconda_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_imposta_seconda_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_base_input_text, {
                id: "detrazione_credito_imposta_seconda_permuta",
                name: "detrazione_credito_imposta_seconda_permuta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).detrazione_credito_imposta_seconda_permuta,
                "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).detrazione_credito_imposta_seconda_permuta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_45, [
              _createTextVNode(_toDisplayString(_unref(validazione).terreno_agricolo_seconda_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.terreno_agricolo_seconda_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_base_input_checkbox, {
                class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                name: "terreno_agricolo_seconda_permuta",
                label: "Sì, è un terreno agricolo",
                "validate-to": _unref(validazione).terreno_agricolo_seconda_permuta,
                "onUpdate:validateTo": _cache[14] || (_cache[14] = $event => ((_unref(validazione).terreno_agricolo_seconda_permuta) = $event))
              }, null, 8 /* PROPS */, ["class", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_48, [
              _createTextVNode(_toDisplayString(_unref(validazione).terreno_pertinenza_seconda_permuta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.terreno_pertinenza_seconda_permuta.ref]
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_component_base_input_checkbox, {
                class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                name: "terreno_pertinenza_seconda_permuta",
                label: "Si, è di pertinenza",
                "validate-to": _unref(validazione).terreno_pertinenza_seconda_permuta,
                "onUpdate:validateTo": _cache[15] || (_cache[15] = $event => ((_unref(validazione).terreno_pertinenza_seconda_permuta) = $event))
              }, null, 8 /* PROPS */, ["class", "validate-to"])
            ])
          ]),
          _cache[26] || (_cache[26] = _createElementVNode("hr", { class: "crm:mt-2! crm:mb-4!" }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_50, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_51, [
              _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_preliminare.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_preliminare.ref]
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_base_input_text, {
                id: "detrazione_credito_preliminare",
                name: "detrazione_credito_preliminare",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).detrazione_credito_preliminare,
                "onUpdate:validateTo": _cache[16] || (_cache[16] = $event => ((_unref(validazione).detrazione_credito_preliminare) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_54, [
              _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createVNode(_component_base_select, {
                name: "forma_del_titolo",
                options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                isSelected: _unref(validazione).forma_del_titolo.value != '',
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).forma_del_titolo,
                "onUpdate:validateTo": _cache[17] || (_cache[17] = $event => ((_unref(validazione).forma_del_titolo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          (_unref(regimeFiscale) == 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_57, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    onChange: _cache[18] || (_cache[18] = $event => (!props.disabilita ? ritenutaAccontoSelezionata($event) : '')),
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[19] || (_cache[19] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "valore_prima_permuta",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'permutaTraBeniIva')
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_61, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore_ciascuna_permuta.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_ciascuna_permuta.ref]
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_component_base_input_text, {
                  id: "valore_ciascuna_permuta",
                  name: "valore_ciascuna_permuta",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).valore_ciascuna_permuta,
                  "onUpdate:validateTo": _cache[20] || (_cache[20] = $event => ((_unref(validazione).valore_ciascuna_permuta) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_64, [
                _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createVNode(_component_base_select, {
                  name: "forma_del_titolo",
                  options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                  isSelected: _unref(validazione).forma_del_titolo.value != '',
                  state: __props.readonly == true ?'disable':'',
                  validateTo: _unref(validazione).forma_del_titolo,
                  "onUpdate:validateTo": _cache[21] || (_cache[21] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            (_unref(regimeFiscale) == 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_67, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[22] || (_cache[22] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "valore_ciascuna_permuta",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}